import type { SVGProps } from 'react';

const SvgDemographic = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M17.36.24A15.14 15.14 0 0 0 .63 13.56 15.14 15.14 0 0 0 14 30.29a15 15 0 0 0 1.73.1h.45v-1.5a13 13 0 0 1-2-.08 13.62 13.62 0 1 1 15.07-12 14 14 0 0 1-.33 1.83l1.45.37a14 14 0 0 0 .37-2A15.12 15.12 0 0 0 17.36.24" />
      <path d="M6.2 13.1h1.5v6.21H6.2zM10.25 10.58h1.5v8.73h-1.5zM14.45 5.95h1.5V19.3h-1.5zM24.67 21.53h-3.85a2.65 2.65 0 0 0-2 .92 2.62 2.62 0 0 0-.59 2.13l.83 5.13a2.62 2.62 0 0 0 2.6 2.21h2.18a2.61 2.61 0 0 0 2.59-2.21l.84-5.13a2.62 2.62 0 0 0-2.6-3Zm.33 7.94a1.12 1.12 0 0 1-1.11 1h-2.23a1.13 1.13 0 0 1-1.12-1l-.83-5.13a1.14 1.14 0 0 1 .25-.91 1.12 1.12 0 0 1 .86-.4h3.85a1.09 1.09 0 0 1 .86.4 1.11 1.11 0 0 1 .26.91ZM26.45 16.91a3.64 3.64 0 1 0-3.64 3.64 3.64 3.64 0 0 0 3.64-3.64m-5.77 0a2.14 2.14 0 1 1 2.13 2.14 2.14 2.14 0 0 1-2.13-2.14" />
    </g>
  </svg>
);

export default SvgDemographic;
